<template>
  <div class="position-ab">
    <template v-if="showComponent">
      <template v-if="isNoCommercialGrade">
        <addCommercialGrade
          :skillAndCommon="skillAndCommon"
          :packId="packId"
          ref="addCommercialGrade"
        ></addCommercialGrade>
      </template>
      <template v-else>
        <commercialGradeList
          :skillAndCommon="skillAndCommon"
          ref="commercialGradeList"
        ></commercialGradeList>
      </template>
    </template>
  </div>
</template>

<script>
import addCommercialGrade from "@/app/subSourcingFlow/views/expertEvaluate/subAddCommercialGradeNew.vue";
import commercialGradeList from "@/app/subSourcingFlow/views/expertEvaluate/subCommercialGradeListNew.vue";
import { scpQryExpertScorePackListApi } from "@/app/sourcingFlow/api/scp-expertEvaluation.js";

export default {
  name: "technicalBusinessScore",
  components: {
    addCommercialGrade,
    commercialGradeList
  },
  data() {
    return {
      skillAndCommon: true,
      packId: "", // 一个评分都没有的时候，将第一个包件packId传入
      showComponent: false,
      isNoCommercialGrade: false // 是否是一个评分的都没有
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      scpQryExpertScorePackListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: sessionStorage.getItem("joinId")
      }).then(res => {
        // subPackageFlag: false 不分包
        if (res.data.data.subPackageFlag) {
          if (res.data.data.hasScorePack.length === 0) {
            this.isNoCommercialGrade = true;
          } else {
            this.isNoCommercialGrade = false;
          }
          if (res.data.data.notScorePack.length !== 0) {
            try {
              // 看是否流标 packStatus 1正常5流标
              res.data.data.notScorePack.forEach(item => {
                if (item.packStatus == "1") {
                  this.packId = item.packId;
                  throw Error();
                }
              });
            } catch (e) {
              console.log(e);
            }
          }
        } else {
          // 不分包 scoreFlag：true 已评分
          if (res.data.data.scoreFlag) {
            this.isNoCommercialGrade = false;
          } else {
            this.isNoCommercialGrade = true;
          }
        }
        this.showComponent = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
